import Cookies from 'js-cookie'
import Base64 from '@/utils/Base64'
export const localStore = window.localStorage
export const sessionStore = window.sessionStorage

const TokenKey = 'userid'

const PasswordKey = 'password'
const UsernameKey = 'username'

export function getToken () {
  return Cookies.get(Base64.ENCODE_XJ(TokenKey))
}

export function setToken (token, options = {}) {
  return Cookies.set(Base64.ENCODE_XJ(TokenKey), token, options)
}

export function removeToken () {
  return Cookies.remove(Base64.ENCODE_XJ(TokenKey))
}

export const LoginInfo = {
  set: (name, pwd, id) => {
    try {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * 7) // 保存的天数
      Cookies.set(Base64.ENCODE_XJ(UsernameKey), Base64.ENCODE_XJ(name), { expires: 7 })
      Cookies.set(Base64.ENCODE_XJ(PasswordKey), Base64.ENCODE_XJ(pwd), { expires: 7 })
      Cookies.set(Base64.ENCODE_XJ(TokenKey), Base64.ENCODE_XJ(id), { expires: 7 })
    } catch (err) {
      console.log(err)
    }
  },
  get: () => {
    return {
      [UsernameKey]: Base64.DECODE_XJ(Cookies.get(Base64.ENCODE_XJ(UsernameKey)) || ''),
      [PasswordKey]: Base64.DECODE_XJ(Cookies.get(Base64.ENCODE_XJ(PasswordKey)) || ''),
      [TokenKey]: Base64.DECODE_XJ(Cookies.get(Base64.ENCODE_XJ(TokenKey)) || '')
    }
  },
  remove: () => {
    Cookies.remove(Base64.ENCODE_XJ(UsernameKey))
    Cookies.remove(Base64.ENCODE_XJ(PasswordKey))
    Cookies.remove(Base64.ENCODE_XJ(TokenKey))
  },
  removeForm: () => {
    Cookies.remove(Base64.ENCODE_XJ(UsernameKey))
    Cookies.remove(Base64.ENCODE_XJ(PasswordKey))
  },
  getForm: () => {
    return {
      [UsernameKey]: Base64.DECODE_XJ(Cookies.get(Base64.ENCODE_XJ(UsernameKey)) || ''),
      [PasswordKey]: Base64.DECODE_XJ(Cookies.get(Base64.ENCODE_XJ(PasswordKey)) || ''),
      remember: !!Cookies.get(Base64.ENCODE_XJ(UsernameKey)) && !!Cookies.get(Base64.ENCODE_XJ(PasswordKey))
    }
  },
  getFormRemember: () => {
    return Cookies.get('rememberMe')
  }
}

const isObject = (value) => {
  return value && typeof value === 'object'
}

/** localStorage */
export const $local = {
  set: function (key, value, expire = null) {
    console.log('wwwwwwwwwwwwwwwww-------- $local.set------------>key, value, expire:', key, value, expire);
    if (key) {
      if (value) {
        if (isObject(value)) {
          value = JSON.stringify(value)
        } else {
          value += ''
        }
        value = Base64.ENCODE_XJ(value)
        if (expire) {
          localStore.setItem(key, value, expire)
        } else {
          localStore.setItem(key, value)
        }
        console.log('wwwwwwwwwwwwwwwww-------- $local.set------------>localStore:', localStore);
      } else {
        localStore.removeItem(key)
      }
    }
  },
  get: function (key, type) {
    try {
      let result = key ? localStore.getItem(key) : ''

      result = result ? Base64.DECODE_XJ(result) : ''

      if (!type) {
        return result
      }
      if (type === 'array') {
        return result ? JSON.parse(result) : []
      } else if (type === 'object') {
        return result ? JSON.parse(result) : {}
      }
    } catch (err) {
      return []
    }
  },
  remove: function (key) {
    if (key) {
      localStore.removeItem(key)
    }
  },
  clear: function () {
    localStore.clear()
  }
}

/** sessionStorage */
export const $session = {
  set: function (key, value, expire = null) {
    if (key) {
      if (value) {
        if (isObject(value)) {
          value = JSON.stringify(value)
        } else {
          value += ''
        }
        value = Base64.ENCODE_XJ(value)
        if (expire) {
          sessionStore.setItem(key, value, expire)
        } else {
          sessionStore.setItem(key, value)
        }
      } else {
        sessionStore.removeItem(key)
      }
    }
  },
  get: function (key, type) {
    let result = key ? sessionStore.getItem(key) : ''

    result = result ? Base64.DECODE_XJ(result) : ''

    if (!type) {
      return result
    }
    if (type === 'array') {
      return result ? JSON.parse(result) : []
    } else if (type === 'object') {
      return result ? JSON.parse(result) : {}
    }
  },
  remove: function (key) {
    if (key) {
      sessionStore.removeItem(key)
    }
  },
  clear: function () {
    sessionStore.clear()
  }
}
